import React from 'react'
import Routes from './Routes'
// import { Container} from 'semantic-ui-react'

export default () => (
    <div>
        <Routes />
    </div>
)


// WEBPACK FOOTER //
// ./src/front/features/ui/components/App.js